import React from 'react';
import { Input } from '@spark';
import { HelpIcon } from '../shared/TaskTypeControls';

export const TOOL_EXECUTION_HELP =
    'Where the trained agent will run the discovered tools: an MCP server or a REST API base URL.';

export const EXECUTION_URL_PLACEHOLDER = 'https://tools.companyname.ai/mcp';

/** Label of the field on the Manual card (Figma 4012:16639). */
export const MANUAL_EXECUTION_LABEL = 'Tool Execution (MCP/Rest API)';
/** Label of the field on the Swagger card (Figma 4012:18367). */
export const SWAGGER_EXECUTION_LABEL = 'Tool Execution';

/**
 * "Tool Execution *" block shared by the Manual and Swagger cards (Figma
 * 4012:16639 / 4012:18367): label + asterisk + help, then one URL input. The
 * protocol (MCP vs REST) is not asked — it is resolved from the source type
 * or at run time.
 */
const ToolExecutionFields = ({
    label = MANUAL_EXECUTION_LABEL,
    url,
    onUrlChange,
    onUrlBlur,
    error = null,
    className = '',
}) => (
    <div className={`cw-ac-execution ${className}`.trim()}>
        <div className="cw-section-label cw-ac-execution__label">
            {label}
            <span className="cw-required-asterisk">*</span>
            <HelpIcon text={TOOL_EXECUTION_HELP} />
        </div>
        <Input
            size="medium"
            showLabel={false}
            showHelperText={false}
            placeholder={EXECUTION_URL_PLACEHOLDER}
            aria-label={label}
            value={url}
            danger={Boolean(error)}
            onChange={(e) => onUrlChange(e.target.value)}
            onBlur={onUrlBlur}
            className="cw-ac-execution__url"
        />
        {error && <div className="cw-field-error">{error}</div>}
    </div>
);

export default ToolExecutionFields;
